import ArmyCapacityDetail from "./ArmyCapacityDetail";
import BricksBalance from "./BricksBalance";
import BuildingInfo from "./BuildingInfo";
import BuildingChainDetail from "./BuildingChainDetail";
import BuildingDetail from "./BuildingDetail";
import DevelopmentBalance from "./DevelopmentBalance";
import DucatsBalance from "./DucatsBalance";
import EditNote from "./EditNote";
import FoodBalance from "./FoodBalance";
import GeneralSkillInfo from "./GeneralSkillInfo";
import GeneralStrengthBonusInfo from "./GeneralStrengthBonusInfo";
import GoldBalance from "./GoldBalance";
import GrainBalance from "./GrainBalance";
import HappinessBalance from "./HappinessBalance";
import IronBalance from "./IronBalance";
import MagicEnergyBalance from "./MagicEnergyBalance";
import MagicResearchStepInfo from "./MagicResearchStepInfo";
import ManaBalance from "./ManaBalance";
import PopulationBalance from "./PopulationBalance";
import QualityStepInfo from "./QualityStepInfo";
import QuestList from "./QuestList";
import StoneBalance from "./StoneBalance";
import TechnologyStepInfo from "./TechnolgyStepInfo";
import UpgradeBuilding from "./UpgradeBuilding";
import WeaponsBalance from "./WeaponsBalance";

export const tooltips = {
  ArmyCapacityDetail,
  BricksBalance,
  BuildingInfo,
  BuildingChainDetail,
  BuildingDetail,
  DevelopmentBalance,
  DucatsBalance,
  EditNote,
  FoodBalance,
  GeneralSkillInfo,
  GeneralStrengthBonusInfo,
  GoldBalance,
  GrainBalance,
  HappinessBalance,
  IronBalance,
  MagicEnergyBalance,
  MagicResearchStepInfo,
  ManaBalance,
  PopulationBalance,
  QualityStepInfo,
  QuestList,
  StoneBalance,
  TechnologyStepInfo,
  UpgradeBuilding,
  WeaponsBalance
};
